module.exports = __webpack_public_path__ + "img/photo_2023-11-22 13.51.31.59d536d6.jpg";